export * from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/QuestionResult/hooks/useQuestionResultRemarkMutation";
